(($, window, document, undefined) => {
  $(() => {

    const onSortOpen = () => {
      $(document).on('click', '.dropdown-button', function () {
        $(this).parent().toggleClass('active');
      });
    }

    const onSortSelectClose = () => {
      $(document).on('click', function (e) {
        if (!$(e.target).closest('.dropdown-container').length) {
          $('.dropdown-container').removeClass('active');
        }
      });
    }

    $('.search-filters__filters .btn-outline-primary').on('click', function () {
      $('aside.layout-sidebar-first').find('.search-sidebar').addClass('show');
    });

    $('.search-sidebar__close').on('click', function () {
      $('aside.layout-sidebar-first').find('.search-sidebar').removeClass('show');
    });

    const applyURLWithFilters = (params) => {
      const url = new URL(window.location.href);
      url.pathname = 'search';

      for (const [key, param] of Object.entries(params)) {
        url.searchParams.forEach((_, name) => {
          if (name.startsWith(`${key}`)) {
            url.searchParams.delete(name);
          }
        });

        if (!param || param.length === 0) {
          continue;
        }

        if (Array.isArray(param)) {
          param.filter(item => item).forEach(item => url.searchParams.append(`${key}[]`, item));
        } else {
          url.searchParams.set(key, param.toString());
        }
      }

      location.assign(url.toString())
    };

    const getThemes = () => $.map(
      $('.theme-filter-checkbox').filter(':checked'),
      theme => $(theme).data('themes')
    ).flat()

    const getDestinations = () => {
      let destinations = $.map(
        $('.destination-filter-checkbox').filter(':checked'),
        destination => $(destination).data('destinations'))
        .flat()

      if (!destinations.length) {
        const generalDestination = $('.block-tour-destination').data('general-destination');

        if (generalDestination) {
          destinations = [generalDestination]
        }
      }

      return destinations
    }

    const getGeneralDestination = () => $('#block-tour-destination').data('general-destination')

    const getDuration = () => $.map(
      $('.duration-filter-checkbox').filter(':checked'),
      duration => $(duration).val()
    ).flat()

    const getTripTypes = () => $.map(
      $('.trip-type-filter-checkbox').filter(':checked'),
      tripType => $(tripType).val()
    ).flat()

    const getPrices = () => $.map(
      $('.price-filter-checkbox').filter(':checked'),
      price => $(price).val()
    ).flat()

    const getSorting = () => $('.search-filters__select .dropdown-content .option').filter('selected').data('value')

    const onApplyFilters = () => {
      const selectors = [
        '.theme-filter-checkbox',
        '.destination-filter-checkbox',
        '.duration-filter-checkbox',
        '.trip-type-filter-checkbox',
        '.price-filter-checkbox',
      ].join(',')

      $(selectors).on({
        change: (e) => {
          const args = {
            general_destination: getGeneralDestination(),
            destinations: getDestinations(),
            themes: getThemes(),
            duration: getDuration(),
            trip_types: getTripTypes(),
            prices: getPrices(),
            sort: getSorting(),
          };

          applyURLWithFilters(args)
        }
      })
    }

    const onSortSelect2 = () => {
      $('.search-filters__select .dropdown-content .option').on({
        click: (e) => {
          const $target = $(e.target)
          const sortValue = $target.data('value')
          const args = {
            general_destination: getGeneralDestination(),
            destinations: getDestinations(),
            themes: getThemes(),
            duration: getDuration(),
            trip_types: getTripTypes(),
            prices: getPrices(),
            sort: sortValue,
          };

          applyURLWithFilters(args)
        }
      })
    }

    const onLoadMoreTours = () => {
      $(document).ajaxSuccess((event, xhr, settings) => {
        if (!settings.url.includes("admin-ajax.php")) {
          return;
        }

        const postData = new URLSearchParams(settings.data);

        if (postData.get("action") !== "load_more_trip") {
          return;
        }

        $('.tooltip').not('.tooltipstered').tooltipster({
          theme: 'tooltipster-light',
          trigger: 'click',
          maxWidth: '200'
        });
      });
    }

    function init() {
      onSortOpen()
      onSortSelectClose()
      onApplyFilters()
      onSortSelect2()
      onLoadMoreTours()
    }

    init();

  });
})(window['jQuery'], window, document);
